import api from '@/apis/di/stockAPI.js';
import CrudCache from '@/stores/crudBaseCache.js';
var crud = new CrudCache('stock', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_stock',
    field: {
      key: 'stock_id',
      code: 'stock_code',
      name: 'stock_name',
      quickFollow: 'inactive', // NTLoc-2022/05/06 : thêm key để update trạng thái theo dõi
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
